var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import 'reflect-metadata';
export class CertificateAnalysis {
    id;
    type;
    createdDate;
    resource;
    project;
    snapshot;
    context;
    alerts;
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], CertificateAnalysis.prototype, "createdDate", void 0);
export class TransparencyAnalysis {
    id;
    type;
    createdDate;
    root;
    project;
    snapshot;
    context;
    alerts;
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], TransparencyAnalysis.prototype, "createdDate", void 0);
export class WebAnalysis {
    id;
    type;
    createdDate;
    test;
    project;
    snapshot;
    context;
    alerts;
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], WebAnalysis.prototype, "createdDate", void 0);
export class DNSAnalysis {
    id;
    type;
    createdDate;
    domain;
    project;
    snapshot;
    context;
    alerts;
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], DNSAnalysis.prototype, "createdDate", void 0);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWxlcnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZG9tYWluL2RhdGEtdHJhbnNmZXItb2JqZWN0cy9hbGVydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFDekMsT0FBTyxrQkFBa0IsQ0FBQztBQWlJMUIsTUFBTSxPQUFPLG1CQUFtQjtJQUM5QixFQUFFLENBQVU7SUFDWixJQUFJLENBQWlCO0lBRXJCLFdBQVcsQ0FBUTtJQUNuQixRQUFRLENBQVM7SUFDakIsT0FBTyxDQUFXO0lBQ2xCLFFBQVEsQ0FBdUI7SUFDL0IsT0FBTyxDQUFZO0lBQ25CLE1BQU0sQ0FBVztDQUNsQjtBQU5DO0lBREMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQzs4QkFDSCxJQUFJO3dEQUFDO0FBUXJCLE1BQU0sT0FBTyxvQkFBb0I7SUFDL0IsRUFBRSxDQUFVO0lBQ1osSUFBSSxDQUFrQjtJQUV0QixXQUFXLENBQVE7SUFDbkIsSUFBSSxDQUFRO0lBQ1osT0FBTyxDQUFXO0lBQ2xCLFFBQVEsQ0FBYztJQUN0QixPQUFPLENBQVk7SUFDbkIsTUFBTSxDQUFXO0NBQ2xCO0FBTkM7SUFEQyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDOzhCQUNILElBQUk7eURBQUM7QUFRckIsTUFBTSxPQUFPLFdBQVc7SUFDdEIsRUFBRSxDQUFVO0lBQ1osSUFBSSxDQUFTO0lBRWIsV0FBVyxDQUFRO0lBQ25CLElBQUksQ0FBUTtJQUNaLE9BQU8sQ0FBVztJQUNsQixRQUFRLENBQWdCO0lBQ3hCLE9BQU8sQ0FBWTtJQUNuQixNQUFNLENBQVc7Q0FDbEI7QUFOQztJQURDLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUM7OEJBQ0gsSUFBSTtnREFBQztBQVFyQixNQUFNLE9BQU8sV0FBVztJQUN0QixFQUFFLENBQVU7SUFDWixJQUFJLENBQVM7SUFFYixXQUFXLENBQVE7SUFDbkIsTUFBTSxDQUFVO0lBQ2hCLE9BQU8sQ0FBVztJQUNsQixRQUFRLENBQWU7SUFDdkIsT0FBTyxDQUFZO0lBQ25CLE1BQU0sQ0FBVztDQUNsQjtBQU5DO0lBREMsSUFBSSxDQUFDLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQzs4QkFDSCxJQUFJO2dEQUFDIn0=